import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import timezones, { guessedTimezone } from '../../utils/timezones';
export default {
  name: 'CoreTimezoneSelector',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      selectedItem: this.value,
      items: timezones,
      guessedTimezone: guessedTimezone,
      commonAttrs: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    required: function required() {
      return this.$attrs.required !== undefined && this.$attrs.required !== false;
    },
    clearable: function clearable() {
      return this.selectedItem !== this.guessedTimezone && this.$attrs.clearable !== undefined && this.$attrs.clearable !== false;
    },
    label: function label() {
      return this.$attrs.label || this.$i18n_t('Common.selectTimezone');
    }
  }),
  watch: {
    value: function value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedItem = newValue;
      }
    }
  },
  mounted: function mounted() {
    if (!this.value) {
      this.setGuessedTimezone();
    }
  },
  methods: {
    setGuessedTimezone: function setGuessedTimezone() {
      var _this = this;

      this.$nextTick(function () {
        _this.selectedItem = _this.guessedTimezone;

        _this.$emit('input', _this.selectedItem);
      });
    }
  }
};